import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { ICON_TYPE, IconModule } from "@spartacus/storefront";
import { I18nModule } from "@spartacus/core";

@Component({
  selector: 'sanofi-pagination',
  standalone: true,
  imports: [
    NgSelectModule,
    FormsModule,
    IconModule,
    I18nModule
  ],
  templateUrl: './pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent {
  readonly mix = input<string>('');
  readonly totalPages = input.required<number>();
  readonly totalResults = input.required<number>();
  readonly currentResultsSize = input.required<number>();
  readonly pageSizeList = input<number[]>([10, 25, 50]);
  readonly currentPageSize = model.required<number>();
  readonly currentPage = model.required<number>();
  readonly resultsLoading = input.required<boolean>();

  pageSizeChange = output();

  protected readonly ICON_TYPE = ICON_TYPE;

  changePageSize(page: number): void {
    this.currentPage.set(0);
    this.currentPageSize.set(page);
  }

  previousPage(): void {
    if (this.currentPage() <= 0 || this.resultsLoading()) {
      return;
    }

    this.currentPage.set(this.currentPage() - 1);
  }

  nextPage(): void {
    if (this.noNextPage()) {
      return;
    }

    this.currentPage.set(this.currentPage() + 1);
  }

  noNextPage(): boolean {
    return this.currentPageSize() > this.totalResults() || this.resultsLoading();
  }
}
